// extracted by mini-css-extract-plugin
module.exports = {"WireTable":"WireTable__WireTable___11xYl","SubTitels":"WireTable__SubTitels___1CYvj"};